import { Box } from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";
import React, { type FormEvent } from "react";
import { Modal } from "@revoo/design-system/ui/Modal/Modal";
import { Header3 } from "@revoo/design-system/ui/Typography/Header3";
import { Text1 } from "@revoo/design-system/ui/Typography/Text1";
import { LinkStyled } from "@revoo/design-system/ui/Typography/LinkStyled";
import { useFormContext } from "react-hook-form";
import { Button } from "@revoo/design-system/ui/Button/Button";
import ReactMarkdown from "react-markdown";
import { useUpdateFeatureFlagsMutation } from "@/libs/settings/redux/settings.api";
import { useFeatureFlagsContext } from "@/libs/shared/providers/FeatureFlagsProvider";
import { CONTACT_LINK } from "@/libs/shared/constants";
import { useSelectCurrentUser } from "@/libs/auth/redux/auth.slice";

const ProcessorFlagsModal = () => {
  const { flags: { data_processor } = {}, setIsOpenProcessor } =
    useFeatureFlagsContext();
  const { t } = useTranslation();
  const user = useSelectCurrentUser();
  const markdownText = t("FeatureFlags:data_processor:policy").replace(
    "[EMAIL]",
    user?.email || "",
  );

  const { handleSubmit } = useFormContext();

  const [updateFlags, { isLoading }] = useUpdateFeatureFlagsMutation();

  return (
    <Modal
      isOpen
      alignContent="center"
      justifyContent="center"
      onClose={() => {}}
      hasClosedButton={false}
      bodyProps={{
        alignContent: "center",
        justifyContent: "center",
      }}
      size="lg"
    >
      <Box
        mt={-8}
        mx="auto"
        as="form"
        display="flex"
        flexDirection="column"
        alignContent="center"
        justifyContent="center"
        onSubmit={(event: FormEvent<HTMLFormElement>) => {
          void handleSubmit(updateFlags)(event).then(() => {
            setIsOpenProcessor(false);
          });
        }}
        width="100%"
      >
        {!data_processor && (
          <Box my={8}>
            <Header3
              mb={3}
              fontSize={{
                base: "md",
                sm: "xl",
              }}
            >
              <Trans i18nKey="FeatureFlags:data_processor:title" />
            </Header3>
            <Text1 mb={4}>
              <Trans i18nKey={"FeatureFlags:data_processor:description"} />
            </Text1>
            <Box
              px={4}
              py={3}
              mb={1}
              height={150}
              overflowY="auto"
              border="1px solid"
            >
              <Text1 pl={4}>
                <ReactMarkdown
                  components={{
                    a: ({ ...props }) => (
                      <a {...props} tabIndex={-1}>
                        {props.children}
                      </a>
                    ),
                  }}
                >
                  {markdownText}
                </ReactMarkdown>
              </Text1>
            </Box>
          </Box>
        )}
        <Button size="lg" type="submit" variant="solid" isLoading={isLoading}>
          <Trans i18nKey="FeatureFlags:submit" />
        </Button>
        <LinkStyled as="a" mt={4} target="_blank" href={CONTACT_LINK}>
          <Trans i18nKey="FeatureFlags:contact" />
        </LinkStyled>
      </Box>
    </Modal>
  );
};

export default ProcessorFlagsModal;
